__turbopack_context__.v({
  "tiltFx": "TiltFx-module-scss-module__cYikgq__tiltFx",
});
